import React, { useEffect, useState } from "react";
import sanityClient from "../client.js";
import "../css/About.css";
import imageUrlBuilder from "@sanity/image-url";
import SanityBlockContent from "@sanity/block-content-to-react";

const builder = imageUrlBuilder(sanityClient);
function urlFor(source) {
  return builder.image(source);
}

export default function About() {
  const [author, setAuthor] = useState(null);

  useEffect(() => {
    sanityClient
      .fetch(`*[_type == "author"]{
        name,
        bio,
        "authorImage": image{
          asset->{
            _id,
            url
          },
          crop,
          hotspot
        }
      }`)
      .then((data) => {
        setAuthor(data[0]);
        console.log(data);
      })
      .catch(console.error);
  }, []);

  if (!author) return <div>Loading...</div>;

  return (
    <main>
      <div className="about-body">
          <div className="about-hero">
            <img
              className="hero-inlay-image"
              src={urlFor(author.authorImage).width(800).url()}
              alt={author.name}
            />
          </div>
          <section>
          <div className="about-text-container">
            <h2>Multi-disciplinary creator and developer specializing in the arts and creative processes.</h2>
            <div>
              <SanityBlockContent
                blocks={author.bio}
                projectId="066s3bew"
                dataset="production"
              />
            </div>
          </div>
          </section>
      </div>
    </main>
  );
}